import get from 'lodash/get'

import {
  fetchCollection
} from './index'

import { issueHistorySchema } from '../schemas'

export const FETCH_ISSUE_HISTORY_REQUEST = 'FETCH_ISSUE_HISTORY_REQUEST'
export const FETCH_ISSUE_HISTORY_SUCCESS = 'FETCH_ISSUE_HISTORY_SUCCESS'
export const FETCH_ISSUE_HISTORY_FAILURE = 'FETCH_ISSUE_HISTORY_FAILURE'

export function fetchHistoriesForIssue (url, issueId) {
  return fetchCollection({
    url,
    key: 'issueHistories',
    schema: issueHistorySchema,
    actions: [ FETCH_ISSUE_HISTORY_REQUEST, FETCH_ISSUE_HISTORY_SUCCESS, FETCH_ISSUE_HISTORY_FAILURE ],
    responseInterceptor: response => ({ ...response, issueId })
  })
}

export function loadHistoriesForIssue (issueId, nextPage, reload) {
  const firstPageUrl = `/issues/${issueId}/history`

  return (dispatch, getState) => {
    let {
      nextPageUrl = firstPageUrl,
      pageCount = 0
    } = get(getState(), `pagination.historiesByIssue.${issueId}`, {})

    if (reload) {
      nextPageUrl = firstPageUrl
    }

    if (pageCount > 0 && !nextPage && !reload) {
      return null
    }

    return dispatch(fetchHistoriesForIssue(nextPageUrl, issueId))
  }
}



// WEBPACK FOOTER //
// ./src/actions/issue-histories.js